import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { Button } from '@hivebrite/design-system/Button';

import { useBuilderContext } from 'hb-builder/hooks';
import { setItem } from 'hb-react/shared/utils/sessionStorage';

const SESSION_STORAGE_KEY = 'hivebrite-new-builder-confirmation-delete-modal';

const ModalActions = ({ closeModal, id, skipConfirmation, onConfirm }) => {
  const { removeItem } = useBuilderContext();

  const storeUserSkipConfirmation = () => {
    setItem({ key: SESSION_STORAGE_KEY, value: skipConfirmation });
  };

  return (
    <ModalButtons>
      <DangerButton
        fontFamily="Inter"
        mr={4}
        onClick={() => {
          storeUserSkipConfirmation();
          onConfirm?.();
          removeItem(id);
          closeModal();
        }}
        variant="primary"
      >
        {__('Delete')}
      </DangerButton>
      <CancelButton onClick={closeModal} variant="secondary">
        {__('Cancel')}
      </CancelButton>
    </ModalButtons>
  );
};

export default ModalActions;

const ModalButtons = styled(Box).attrs(() => ({
  mt: '30px',
  mb: '10px',
}))``;

// Remove this style when variant exist
const DangerButton = styled(Button)`
  background-color: #fd4329 !important;
  box-shadow: 0 2px 6px 0 rgb(250 92 124 / 50%);

  &:hover {
    background-color: #ee395b !important;
    transition: background-color 150;
  }
`;
const CancelButton = styled(Button)`
  height: 33px;
  &:hover {
    box-shadow: 0 2px 6px 0 rgb(227 234 239 / 50%);
    background-color: #cbd8e1;
    color: #313a46;
    transition: background-color 150, color 150;
  }
`;
